import * as React from 'react';
import TractDetailData from 'src/models/tract_detail/TractDetail';
import Dialog from 'src/components/common/Dialog';
import PropertyUtil from 'src/util/PropertyUtil';
import * as _ from 'lodash';
import { FormApi } from 'final-form';
import SearchResult from 'src/models/OwnerSearchResult';
import AddOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddOwnership';
import './OwnerSearch.scss';
import PagedResultSet from 'src/models/common/PagedResultSet';
import { ODataOptions } from 'src/util/ODataBuilder';
import State from 'src/models/State';
import IOwner from 'src/models/IOwner';
import PhoneNumberType from 'src/models/PhoneNumberType';
import USPSCityState from 'src/models/USPSCityState';
import OwnershipFormUtil from './OwnershipFormUtil';
import AddOwner from 'src/models/tract_detail/add_ownership_revised/AddOwner';
import ExistingOwnerForm from './ExistingOwnerForm';
import AddOwnershipPages from './AddOwnershipPages';
import NewOwnerForm from './NewOwnershipForm';
import OwnerType from './OwnerType';
import AddWIOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddWIOwnership';
import DialogList from 'src/dialogs';
import { AnyObject } from 'react-final-form';
import { FormErrors } from 'src/util/FormErrors';
import LeaseGenerationTractDetail from 'src/models/leasing/LeaseGenerationTractDetail';

export interface IAddOwnershipProps {
    navigate: (path: string) => void;
    searchOwners: (searchText: string, ownerType: string) => void;
    getOwnerDetail: (ownerLookupId: number, containerId: number, type: string) => void;
    saveAddTractOwnership?: (values: AddOwnershipData) => void;
    saveAddLeaseOwnership?: (values: AddWIOwnershipData, isClientAcreage: boolean) => void;
    addDeviation: (values: AddOwner, containerOwnerId: number, ownerType: string) => void;
    getStates: (options: ODataOptions) => void;
    hideDialog: () => void;
    getPhoneNumberTypes: () => void;
    getTractsByOwnerId: (ownerId: number) => void;
    getCityState: (zipCode: string) => void;
    initializeOwnerTracts: () => void;
    clearSearchResults: () => void;
    getScrollStatus?: (divElement: HTMLDivElement) => void;
}

export type IAddOwnershipStateProps = {
    dialogName: DialogList;
    title: string;
    tract?: TractDetailData;
    horizon?: number;
    searchResults?: PagedResultSet<SearchResult>;
    ownerDetails?: Array<IOwner>;
    states: PagedResultSet<State>;
    parentOwnershipId?: number;
    phoneNumberTypes: Array<PhoneNumberType>;
    ownerTracts: Array<LeaseGenerationTractDetail>;
    clientNumber: number;
    projectNumber: number;
    uspsCityState: USPSCityState;
};

type AddOwnershipState = {
    page: AddOwnershipPages;
};

// add owner types
const ownerTypes = [
    { id: OwnerType.Individual, name: 'Individual' },
    { id: OwnerType.Trust, name: 'Trust' },
    { id: OwnerType.Business, name: 'Business' },
    { id: OwnerType.GovBLM, name: 'Gov-BLM' },
    { id: OwnerType.GovRAL, name: 'Gov-RAL' },
    { id: OwnerType.GovSTATE, name: 'Gov-STATE' },
    { id: OwnerType.JointTenant, name: 'Joint Tenant' },
];

const ownershipType = ['FEE', '0', '1'];

type IAddOwnershipPageProps = IAddOwnershipProps & IAddOwnershipStateProps;

class AddOwnership extends React.Component<IAddOwnershipPageProps, AddOwnershipState> {
    constructor(props: IAddOwnershipPageProps) {
        super(props);

        this.state = {
            page: AddOwnershipPages.AddOwnershipLandingPage,
        };
    }

    private newOwnerForm: FormApi;
    private existingOwnerForm: FormApi;

    initializeFormAndState = () => {
        this.props.clearSearchResults();
        this.props.initializeOwnerTracts();
        this.setState({
            page: AddOwnershipPages.AddOwnershipLandingPage,
        });
    };

    componentDidMount() {
        this.props.getPhoneNumberTypes();
        this.props.getStates(new ODataOptions().addPaging(1, 100));
    }

    componentWillUnmount() {
        this.onClose();
    }

    componentDidUpdate(prevProps: IAddOwnershipPageProps) {
        if (!_.isEqual(prevProps, this.props)) {
            if (prevProps.ownerTracts || prevProps.searchResults) {
                this.setState(this.state);
            }
            if (prevProps.uspsCityState?.zipCode?.zip5 !== this.props.uspsCityState?.zipCode?.zip5) {
                if (this.state.page === AddOwnershipPages.NewOwnerInfoForm) {
                    OwnershipFormUtil.alterCityState(
                        PropertyUtil.SafeGet(() => this.props.states.items),
                        this.props.uspsCityState,
                        this.newOwnerForm
                    );
                } else if (this.state.page === AddOwnershipPages.NewDeviationInfoForm) {
                    OwnershipFormUtil.alterCityState(
                        PropertyUtil.SafeGet(() => this.props.states.items),
                        this.props.uspsCityState,
                        this.existingOwnerForm
                    );
                }
            }
        }
    }

    onClose = () => {
        this.initializeFormAndState();
        this.props.hideDialog();
    };
    onNewOwnerFormCreated = (form: FormApi) => {
        this.newOwnerForm = form;
    };
    onExistingOwnerFormCreated = (form: FormApi) => {
        this.existingOwnerForm = form;
    };
    cleanValues = (values: AnyObject) => {
        console.log('clean values', values);
        if (values.ownership && values.ownership.ownershipType) {
            values.ownership.ownershipType = ownershipType.find((x, index) => index === parseInt(values.ownership.ownershipType, 10));
        }
        if (values.ownerType) {
            values.ownerType = parseInt(values.ownerType + '', 10);
        }
        if (values.ownership && values.ownership.decimalInterest) {
            values.ownership.decimalInterest = parseFloat(values.ownership.decimalInterest + '');
            values.ownership.ownershipType = 'FEE';
        }
        return values;
    };
    submitOwnership = (formValues: AnyObject) => {
        if (this.props.dialogName === DialogList.ADD_OWNERSHIP || this.props.dialogName === DialogList.ADD_ADDITIONAL_OWNERSHIP) {
            const values = this.cleanValues(formValues) as AddOwnershipData;
            console.log('submitOwnership', values);
            this.props.saveAddTractOwnership(values);
        } else if (this.props.dialogName === DialogList.ADD_WI_OWNERSHIP || this.props.dialogName === DialogList.ADD_ORRI_OWNERSHIP) {
            const values = this.cleanValues(formValues) as AddWIOwnershipData;
            const isClient = formValues.owners?.find((o: AnyObject) => o.id === values.ownerLookUpId)?.isClientAcreage ?? false;
            this.props.saveAddLeaseOwnership(values, isClient);
        }

        this.initializeFormAndState();
        this.props.hideDialog();
    };

    validate = (values: AnyObject) => {
        values.ownerType = parseInt(values.ownerType, 10);
        const errors: AnyObject = {};
        if (this.state.page === AddOwnershipPages.NewOwnerDecimalInterest || this.state.page === AddOwnershipPages.DeviationDecimalInterest) {
            if (!_.get(values, 'ownership.decimalInterest')) {
                _.set(errors, 'ownership.decimalInterest', 'Required');
            }
            if (
                this.props.dialogName === DialogList.ADD_ADDITIONAL_OWNERSHIP &&
                this.props.parentOwnershipId > 0 &&
                !_.get(values, 'ownership.additionalOwnershipTypeId')
            ) {
                _.set(errors, 'ownership.additionalOwnershipTypeId', 'Required');
            }
        }
        if (this.state.page === AddOwnershipPages.NewOwnerInfoForm || this.state.page === AddOwnershipPages.NewDeviationInfoForm) {
            if (values.ownerType === OwnerType.Individual) {
                if (!_.get(values, 'individualOwner.firstName')) {
                    _.set(errors, 'individualOwner.firstName', 'Required');
                }
                if (!_.get(values, 'individualOwner.lastName')) {
                    _.set(errors, 'individualOwner.lastName', 'Required');
                }
            } else if (values.ownerType === OwnerType.Trust) {
                if (!_.get(values, 'ownerTrust.trustName')) {
                    _.set(errors, 'ownerTrust.trustName', 'Required');
                }
                if (!_.get(values, 'ownerTrust.contactPersonFirstName')) {
                    _.set(errors, 'ownerTrust.contactPersonFirstName', 'Required');
                }
                if (!_.get(values, 'ownerTrust.contactPersonLastName')) {
                    _.set(errors, 'ownerTrust.contactPersonLastName', 'Required');
                }
                if (!_.get(values, 'ownerTrust.trustees')) {
                    _.set(errors, 'ownerTrust.trustees', 'Required');
                }
            } else if (values.ownerType === OwnerType.Business) {
                if (!_.get(values, 'businessOwner.name')) {
                    _.set(errors, 'businessOwner.name', 'Required');
                }
                if (!_.get(values, 'businessOwner.contactPersonFirstName')) {
                    _.set(errors, 'businessOwner.contactPersonFirstName', 'Required');
                }
                if (!_.get(values, 'businessOwner.contactPersonLastName')) {
                    _.set(errors, 'businessOwner.contactPersonLastName', 'Required');
                }
            } else if (values.ownerType === OwnerType.GovBLM) {
                if (!_.get(values, 'bolmOwner.regionalOffice')) {
                    _.set(errors, 'bolmOwner.regionalOffice', 'Required');
                }
                if (!_.get(values, 'bolmOwner.contactPersonFirstName')) {
                    _.set(errors, 'bolmOwner.contactPersonFirstName', 'Required');
                }
                if (!_.get(values, 'bolmOwner.contactPersonLastName')) {
                    _.set(errors, 'bolmOwner.contactPersonLastName', 'Required');
                }
            } else if (values.ownerType === OwnerType.GovRAL) {
                if (!_.get(values, 'ralOwner.stateId')) {
                    _.set(errors, 'ralOwner.stateId', 'Required');
                }
                if (!_.get(values, 'ralOwner.surfaceOwnerAgentFirstName')) {
                    _.set(errors, 'ralOwner.surfaceOwnerAgentFirstName', 'Required');
                }
                if (!_.get(values, 'ralOwner.surfaceOwnerAgentLastName')) {
                    _.set(errors, 'ralOwner.surfaceOwnerAgentLastName', 'Required');
                }
            } else if (values.ownerType === OwnerType.GovSTATE) {
                if (!_.get(values, 'stateLandOwner.agencyName')) {
                    _.set(errors, 'stateLandOwner.agencyName', 'Required');
                }
                if (!_.get(values, 'stateLandOwner.contactPersonFirstName')) {
                    _.set(errors, 'stateLandOwner.contactPersonFirstName', 'Required');
                }
                if (!_.get(values, 'stateLandOwner.contactPersonLastName')) {
                    _.set(errors, 'stateLandOwner.contactPersonLastName', 'Required');
                }
            } else if (values.ownerType === OwnerType.JointTenant) {
                // ownerJointTenant.name
                if (!_.get(values, 'ownerJointTenant.name')) {
                    _.set(errors, 'ownerJointTenant.name ', 'Required');
                }
            }
        }
        // console.log(errors);
        return errors as FormErrors<AnyObject>;
    };

    render() {
        return (
            <Dialog dialogName={this.props.dialogName} title={this.props.title} onCloseDialog={() => this.onClose()}>
                <div style={{ width: '100rem' }}>
                    <NewOwnerForm
                        validate={this.validate}
                        submitOwnership={this.submitOwnership}
                        dialogType={this.props.dialogName}
                        getCityState={this.props.getCityState}
                        horizon={this.props.horizon}
                        ownerTypes={ownerTypes}
                        ownershipType={ownershipType}
                        page={this.state.page}
                        phoneNumberTypes={this.props.phoneNumberTypes}
                        searchResults={this.props.searchResults}
                        states={this.props.states}
                        tract={this.props.tract}
                        turnPage={(addOwnershipPage) => this.setState({ page: addOwnershipPage })}
                        parentOwnershipId={this.props.parentOwnershipId}
                        initializeFormAndState={this.initializeFormAndState}
                        isLeasehold={true}
                    />
                    <ExistingOwnerForm
                        clientNumber={this.props.clientNumber}
                        projectNumber={this.props.projectNumber}
                        getCityState={this.props.getCityState}
                        getTractsByOwnerId={this.props.getTractsByOwnerId}
                        horizon={this.props.horizon}
                        ownerDetails={this.props.ownerDetails}
                        ownerTracts={this.props.ownerTracts}
                        ownerTypes={ownerTypes}
                        page={this.state.page}
                        phoneNumberTypes={this.props.phoneNumberTypes}
                        submitOwnership={this.submitOwnership}
                        validate={this.validate}
                        searchOwners={this.props.searchOwners}
                        searchResults={this.props.searchResults}
                        states={this.props.states}
                        tract={this.props.tract}
                        turnPage={(addOwnershipPage) => this.setState({ page: addOwnershipPage })}
                        addDeviation={this.props.addDeviation}
                        getOwnerDetail={this.props.getOwnerDetail}
                        parentOwnershipId={this.props.parentOwnershipId}
                        dialogType={this.props.dialogName}
                        isLeasehold={true}
                        getScrollStatus={this.props.getScrollStatus}
                    />
                </div>
            </Dialog>
        );
    }
}

export default AddOwnership;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/AddOwnership.tsx